import React, { createContext, FC, ReactElement, ReactNode, useEffect, useState } from 'react'
import { EMPTY_STRING } from '../../../NonReact/constants/Common'
import { IsStringEmpty, isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { ReactState } from '../Types/Types'
import { Branding, getBranding } from '../API/BrandingAPI'
import { APIElements } from '../../../NonReact/constants/ApiConstants'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export type ServletPathContextType = string | undefined

type Props = {
    value?: string
    children: ReactNode
}

const BASE_URL: string = `/${APIElements.CCS}/${APIElements.API_APP}/`

export const ServletPathContextProvider: FC<Props> = ({ value, children }: Props): ReactElement => {
    const [servletPath, setServletPath]: ReactState<string> = useState<string>(value ?? EMPTY_STRING)

    useEffect((): void => {
        if (IsStringEmpty(value) || value.length <= BASE_URL.length) {
            getBranding().then((branding: JSONResponse<Branding>): void =>
                setServletPath(
                    `${BASE_URL}${
                        isStringNotEmpty(branding?.URLMapping)
                            ? branding?.URLMapping?.replace('/', '')
                            : APIElements.AKIXI_2019
                    }`
                )
            )
        }
    }, [])

    return <ServletPathContext.Provider value={servletPath}>{children}</ServletPathContext.Provider>
}

/**
 * Context for servlet path.
 */
const ServletPathContext = createContext<ServletPathContextType>(undefined)
export default ServletPathContext
